<div class="dialog">
    <div class="dialog-header">
        『文件题名』规则
    </div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">
                    固定前部
                </div>
                <div class="column" [style.width]="600 + 'px'">
                    <input type="text" placeholder="请输入案卷题名前面固定部分（可以没有）" [(ngModel)]="record.titleFixedPrefix"
                        (ngModelChange)="genExampleName()">
                </div>
            </div>

            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column background-page spin" [style.height]="440 + 'px'" [style.top]="0" [style.left]="0"
                    [style.width]="70 + 'px'">
                    自动部分
                </div>

                <div class="column background-page" [style.width]="100 + 'px'">
                    各级可参与项
                </div>
                <div class="column background-page" [style.textAlign]="'center'" [style.width]="60 + 'px'">
                    参与项<br />编号
                </div>
                <div class="column background-page" [style.width]="60 + 'px'">
                    示例
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    参与
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    间隔
                </div>
                <div class="column background-page" [style.textAlign]="'center'" [style.width]="60 + 'px'">
                    参与项<br />编号
                </div>
                <div class="column background-page" [style.width]="160 + 'px'">
                    示例
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    参与
                </div>
                <div class="column background-page" [style.width]="40 + 'px'">
                    间隔
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'项目'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="40 + 'px'">

                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'104国道杭州河庄至衙前段'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.PROJECT + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.PROJECT + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'监理'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'合同号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'XSJL-01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SUPERVISION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SUPERVISION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'单位名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'杭州交通工程监理咨询有限公司'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SUPERVISION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SUPERVISION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'施工'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'合同号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'EPC-02'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.CONSTRUCTION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.CONSTRUCTION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'单位名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'浙江交工集团股份有限公司'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.CONSTRUCTION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.CONSTRUCTION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'单位工程'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'Q01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.DW + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.DW + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'主线高架桥(K4+658.396-K6+163.539)'"
                        [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.DW + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.DW + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分部工程'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'01'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.FB + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.FB + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'基础及下部构造（188#~200#墩）'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.FB + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.FB + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分部工程单元'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'02'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SUB_FB + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SUB_FB + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'188#墩'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SUB_FB + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SUB_FB + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分项工程'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'03'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.FX + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.FX + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'钻孔灌注桩'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.FX + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.FX + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分项工程单元'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'04'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SECTION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SECTION + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'名称'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="'188-1#桩基'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SECTION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SECTION + '_' + ArchiveTitleRuleItemParamType.ITEM_NAME].separator">
                </div>
            </div>

            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分段'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'D1'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SEGMENT + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.SEGMENT + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                </div>
            </div>

            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">

                </div>
                <div class="column" [style.width]="100 + 'px'">
                    <format-data [contentStr]="'分层'" [patternStr]="'C000000'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'编号'" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="'C1'" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="checkbox" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.LAYER + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].checked">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                    <input type="text" (ngModelChange)="genExampleName()"
                        [(ngModel)]="ruleItemMap[ArchiveTitleRuleItemType.LAYER + '_' + ArchiveTitleRuleItemParamType.ITEM_SN].separator">
                </div>
                <div class="column" [style.width]="60 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+60@@C7f7f7f'"></format-data>
                </div>
                <div class="column" [style.width]="160 + 'px'">
                    <format-data [contentStr]="''" [patternStr]="'E+160@@Cbdc3c7'"></format-data>
                </div>
                <div class="column" [style.width]="40 + 'px'">
                </div>
                <div class="column" [style.width]="40 + 'px'">
                </div>
            </div>

            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">
                    固定后部
                </div>
                <div class="column" [style.width]="600 + 'px'">
                    <input type="text" placeholder="请输入案卷题名后面固定部分（可以没有）" [(ngModel)]="record.titleFixedSuffix"
                        (ngModelChange)="genExampleName()">
                </div>
            </div>

            <div class="row">
                <div class="column background-page" [style.width]="70 + 'px'">
                    卷名示例
                </div>
                <div class="column background-module" [style.width]="600 + 'px'">
                    <format-data class="color-primary" [contentStr]="exampleName" [patternStr]="'E+600'"></format-data>
                </div>
            </div>
            <div class="row">
                <div class="column no-border" [style.width]="670 + 'px'">
                    <label class="color-primary" nz-checkbox [(ngModel)]="forceUpdate">
                        用新规则刷新已有文件题名（不勾选，本目录下已有文件题名将不更新）
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>